export const TIPO_CLIENTE = {
  PESSOA_FISICA: 'Pessoa Física',
  PESSOA_JURIDICA: 'Pessoa Jurídica',
  FUNDOS: 'Fundos',
  INSTITUCIONAL: 'Institucional',
};
